import styled from 'styled-components';
import { IonCardTitle } from '@ionic/react';

export const Root = styled(IonCardTitle)`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize(18)};
  line-height: ${({ theme }) => theme.fontSize(23)};
`;
